/* ToeFix V7.4: keep the mobile free-shipping stripe moving after drawer morphs. */
(() => {
  const selector = '.cart-drawer .toefix-cart-free-shipping__track > span';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let queued = false;

  function restart() {
    queued = false;
    if (reducedMotion() || !window.matchMedia('(max-width: 749px)').matches) return;
    const fill = document.querySelector(selector);
    if (!fill) return;
    // Safari may freeze a CSS animation when Shopify morphs the drawer in place.
    // Re-arm only the small stripe element; do not touch cart state or checkout.
    fill.style.animation = 'none';
    void fill.offsetWidth;
    fill.style.removeProperty('animation');
  }

  function queueRestart() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => requestAnimationFrame(restart));
  }

  // Native theme events: emitted during cart add/update and on drawer opening.
  ['cart:add', 'cart:update', 'dialog:open'].forEach((eventName) => {
    document.addEventListener(eventName, queueRestart, true);
  });

  function watchDrawer() {
    const drawer = document.querySelector('.cart-drawer');
    if (!drawer) return;
    const observer = new MutationObserver((records) => {
      // Backup for asynchronous section replacement after a cart event.
      // Ignore text/attribute changes and all unrelated subtree updates.
      const swapped = records.some(({ addedNodes, removedNodes }) => {
        for (const node of [...addedNodes, ...removedNodes]) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('.toefix-cart-free-shipping, .cart-drawer__items, .cart-items__wrapper') ||
              node.querySelector?.('.toefix-cart-free-shipping')) return true;
        }
        return false;
      });
      if (swapped) queueRestart();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer, { once: true });
  } else {
    watchDrawer();
  }
})();
